module.exports = __webpack_public_path__ + "static/media/min-k-24.4a20f28d.png";